// extracted by mini-css-extract-plugin
export default {"productCard":"ProductCard_solo_productCard__yB3u8"};